import { brand } from "../config/brands";
import React, { useEffect, useRef, useState } from "react";
import Layout from '../component/Layout';
import { findBusinessByPhoneNumber, getLabels, updateLabel } from "../adapter/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from 'axios';
import { ApiUrlService } from '../api-library/api-services';
import { GoogleMap, LoadScript, Autocomplete, Marker, useLoadScript } from "@react-google-maps/api";
import './BusinessSettings.css';

const BusinessSettings = () => {

  const [labels, setlabels] = useState([]);
  const [checkedBusy, setCheckedBusy] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
    const [businessName, setBusinessName] = useState("");
  const [email, setEmail] = useState("");
  const [logo, setLogo] = useState("");
  const [image, setImage] = useState("");
  const [description, setDescription] = useState("");
  const [discount, setDiscount] = useState(false);
  const [fromTime, setFromTime] = useState('');
  const [toTime, setToTime] = useState('');
  const [allDay, setAllDay] = useState(false);
  const [deliveryTime, setDeliveryTime] = useState("30-45 min");
  const [discountPercentage, setDiscountPercentage] = useState(false);
  const [location, setLocation] = useState({ lat: 33.8938, lng: 35.5018 }); // Default to Beirut, Lebanon
  const [autocomplete, setAutocomplete] = useState(null);
  const [causeTitle, setCauseTitle]=useState("");
  const [causeDescription, setCauseDescription]=useState("");
  const [dollarRate, setDollarRate]=useState("");
  const [deliveryCharge, setDeliveryCharge]=useState("");
  const [aboutUs, setAboutUs]=useState("");
  const [selectedOrder, setSelectedOrder]=useState("");
  const [privacyPolicy, setPrivacyPolicy]=useState("");
  const [aboutUsLink, setAboutUsLink]=useState("");
  const [privacyPolicyLink, setPrivacyPolicyLink]=useState("");

  const scriptRef = useRef(null); // Ref to track the script
   const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
   const libraries = ['places'];
 
   const { isLoaded, loadError } = useLoadScript({
     googleMapsApiKey: googleMapsApiKey,
     libraries,
   });

  const apiUrlService = new ApiUrlService()

  const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  const [openingHours, setOpeningHours] = useState(
    daysOfWeek.map((dayOfWeek) => ({ dayOfWeek, openTime: null, closeTime: null , isClosed: null }))
  );

  const listLabels = async () => {
    setlabels([])
    
    const response = await getLabels();

            setlabels(response.data.data)
            setCheckedBusy(response.data.data.acceptOrder)
  
}

const handleBusyChange = (e) => {
  setCheckedBusy(e.target.checked); // Updates state based on checkbox status
};

const handlePlaceSelect = () => {
  if (autocomplete) {
    const place = autocomplete.getPlace();
    if (place.geometry && place.geometry.location) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      setLocation({ lat, lng });
      console.log('Latitude:', lat, 'Longitude:', lng);
    }
  }
};

const formatTo24Hour = (time) => {
    const [hour, minute, second] = time && time.split(':');
    let hours24 = parseInt(hour);

    // Convert 12-hour to 24-hour format
    if (hours24 < 12) {
      hours24 = hours24 === 12 ? 0 : hours24; // Handle 12 AM case
    } else if (hours24 > 12) {
      hours24 = hours24 === 12 ? 12 : hours24; // For 12 PM, no change needed
    }

    return (`${hours24.toString().padStart(2, '0')}:${minute.padStart(2, '0')}:${second ? second.padStart(2, '0') : '00'}`).replace(/AM|PM/, "");
  };


  useEffect(() => {
    handleGetBusiness();
  }, []); // Runs only once, when the component mounts
  
  // New useEffect to handle updating the form state once selectedOrder is updated
  useEffect(() => {
    if (selectedOrder) {
      setBusinessName(selectedOrder.name || "");
      setFromTime(formatTo24Hour(selectedOrder.fromTime || '10:00:00'));
      setToTime(formatTo24Hour(selectedOrder.toTime || '10:00:00'));
      setPhoneNumber(selectedOrder.phoneNumber || "");
      setDescription(selectedOrder.description || "");
      setDiscount(selectedOrder.onOffer || false);
      setDiscountPercentage(selectedOrder.discountPercentage || "");
      setDeliveryTime(selectedOrder.deliveryTime || "30-45 min");
      setAllDay(selectedOrder.allHours || "");
      setEmail(selectedOrder.email || "");
      setCheckedBusy(selectedOrder.acceptOrder || false);
      setCauseTitle(selectedOrder.causeTitle || "");
      setCauseDescription(selectedOrder.causeDesc || "");
      setOpeningHours(selectedOrder.openingHours || daysOfWeek.map((dayOfWeek) => ({ dayOfWeek, openTime: null, closeTime: null, isClosed: null })))
      if (selectedOrder && selectedOrder.google_map_coordinates) {
        const lat = parseFloat(selectedOrder.google_map_coordinates.x);
        const lng = parseFloat(selectedOrder.google_map_coordinates.y);
    
        // Check if lat and lng are valid numbers
        if (lat && lng) {
          setLocation({ lat, lng });
        } else {
          console.error('Invalid coordinates:', lat, lng);
          // Optionally fallback to a default location if invalid
          setLocation({ lat: 33.8938, lng: 35.5018 });
        }
      }
    }
  }, [selectedOrder]); // This effect runs when selectedOrder changes
  
  const [updatedLogo, setUpdatedLogo] = useState(null);
  const [updatedImage, setUpdatedImage] = useState(null);

  const handleFileChange = (event, type) => {
    const file = event.target.files[0];
    if (type === "logo") {

      setUpdatedLogo(file);
      setLogo(file)
      handleImageChange(file, "logo")
    } else if (type === "image") {
      setUpdatedImage(file);
      setImage(file)
      handleImageChange(file, "image")
    }
  };

  const handleImageChange = async (image, name) => {
    if (image) {
      const formData = new FormData();
      formData.append("file", image);

      try {
        const response = await axios.post(
          `${brand.apiBaseUrl}/saveImage`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (name === "logo") {
          setUpdatedLogo(response.data.data);
          setLogo(response.data.data)
         
        } else {
          setUpdatedImage(response.data.data);
          setImage(response.data.data)
          
        }
      } catch (error) {
        console.error("Error uploading image:", error.message);
        toast.error("Failed to upload image.");
      }
    }
  };

  const handleGetBusiness = async () => {
    const user = await AsyncStorage.getItem("myUser");

      const parsedUser = JSON.parse(user);
      const { role, email } = parsedUser;

      const response = await findBusinessByPhoneNumber(email)
      setSelectedOrder(response.data.data)
    
  }


  

  
  const handleDiscountChange = (e) => {
    setDiscount(e.target.checked); // Updates state based on checkbox status
  };

  const handleAllDayChange = (e) => {
    if(!e.target.checked){
      setFromTime("10:00:00")
      setToTime("10:00:00")
    }
   
    setAllDay(e.target.checked); // Updates state based on checkbox status
  };

  const handleTimeChange = (dayOfWeek, type, value) => {
  setOpeningHours((prev) =>
    prev.map((d) => (dayOfWeek === "Monday" || d.dayOfWeek === dayOfWeek ? { ...d, [type]: value } : d))
  );
};

  const copyMondayToAll = () => {
    setOpeningHours((prev) => {
      const monday = prev.find((day) => day.dayOfWeek === "Monday");
      return monday ? prev.map((day) => ({ ...day, openTime: monday.openTime, closeTime: monday.closeTime, isClosed: monday.isClosed })) : prev;
    });
  };
    

      const handleEditItem = (business) => {

        const body =
        {
          "name": businessName,
          "phoneNumber": phoneNumber,
          "email": email,
          "description": description,
          "logo": updatedLogo ? updatedLogo : selectedOrder.logo,
          "image": updatedImage ? updatedImage : selectedOrder.image,
          "openingHours": openingHours,
          "onOffer": discount,
          "discountPercentage": discountPercentage,
          "deliveryTime": deliveryTime,
          "acceptOrder": checkedBusy,
          "causeTitle":  causeTitle,
          "causeDesc": causeDescription,
          "google_map_coordinates":{
            "x": location.lat,
            "y": location.lng
        },
        }
    
    
        var service = apiUrlService.PutApi(body)
        fetch(`${brand.apiBaseUrl}/restaurant/` + selectedOrder.restaurant_id + '', service).then((response) => response.json())
          .then((response) => {
    
            if (response.status === true) {
              toast.success("Business Updated!");
            
              handleGetBusiness()
            }
          })
      };


  return (
    <Layout>
      <ToastContainer />
    <section className="business-settings-page" aria-label="Business settings">
    <header className="business-settings-header"><div><p>BUSINESS MANAGEMENT</p><h1>Settings</h1><span>Keep your store profile, hours, and customer-facing details up to date.</span></div><button onClick={() => handleEditItem(selectedOrder)}>Save changes</button></header>
    {/* Page content goes here */}
    <hr className="w-full" style={{ border: "1px solid var(--color-border)", margin: "10px 0" }} />

      {/* Main Content */}
      <main className="business-settings-main flex-1 p-8">
        <div className="grid grid-cols-2 gap-8">
          {/* Left Section */}
          <div>
            <h2 className="text-lg font-semibold mb-4"></h2>
            <form className="space-y-4">
            <div className="grid grid-cols-1  gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                    value={businessName}
                    onChange={(e) => setBusinessName(e.target.value)}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div>
                <label className="block text-sm font-medium text-gray-700 mb-1 w-1/3">Discount? </label>
                <input
                  type="checkbox"
                  checked={discount}
                  onChange={handleDiscountChange}
                  className="h-4 p-2 ml-2  w-4 text-blue-600 border-gray-300 rounded"
                />
              </div>

              {discount && <div>
                <label className="block text-sm font-medium text-gray-700 mb-1 w-1/3">Discount(%) </label>
                <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                    value={discountPercentage}
                    onChange={(e) => setDiscountPercentage(e.target.value)}
                  />
              </div>}
              
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                  <textarea
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                    rows="3"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  ></textarea>
                </div>

                <div><label className="block text-sm font-medium text-gray-700 mb-1">Delivery Time</label>
        <input
            type="text"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
            value={deliveryTime}
            onChange={(e) => setDeliveryTime(e.target.value)}
          /></div>

<div className='flex justify-between mt-9'>
                <div>
                  <label style={{width:200}} className="block text-sm font-medium text-gray-700 mb-1">Logo</label>
                  <img
                    src={selectedOrder.logo}
                    alt={selectedOrder.name}
                    className="w-16 h-16 rounded-lg object-cover mr-4 mb-2"
                  />
                  <input
                    type="file"
                    accept="image/*"
                    className="block w-full mb-4"
                    onChange={(e) => handleFileChange(e, "logo")}
                  />
                  </div>

                  <div className='ml-20'>
                  <label style={{width:200}} className="block text-sm font-medium text-gray-700 mb-1 w-100">Background Image</label>
                  <img
                    src={selectedOrder.image}
                    alt={selectedOrder.name}
                    className="w-100 h-16 rounded-lg object-cover mr-4 mb-2"
                  />
                  <input
                    type="file"
                    accept="image/*"
                    className="block w-full mb-4"
                    onChange={(e) => handleFileChange(e, "image")}
                  />
  </div>
  
                </div>
             
                
               
              </div>
              <div className="md:col-span-3">
          <label className="block text-sm font-medium text-gray-700 mb-1">Search Location</label>
          {isLoaded && (
            <Autocomplete onLoad={(auto) => setAutocomplete(auto)} onPlaceChanged={handlePlaceSelect}
              options={{ componentRestrictions: { country: "LB" } }}>
              <input type="text" placeholder="Search for a location" className="w-full px-3 py-2 border border-gray-300 rounded-lg" />
            </Autocomplete>
          )}
           {isLoaded && (
          <GoogleMap center={location} zoom={14} mapContainerStyle={{ height: "200px", width: "100%" }}>
            <Marker position={location} />
          </GoogleMap>)}
        </div>
            </form>
          </div>

          {/* Right Section */}
          <div className="mt-7">
            <h2 className="text-lg font-semibold mb-4"></h2>
            <form className="space-y-4">
            <div>
            <div className="space-x-4"> {/* Add space between child elements */}
  <div className="flex items-center space-x-2 ml-5 mb-5">
        <label className="block text-sm font-medium text-gray-700 mb-1">24 hours? </label>
                <input
                  type="checkbox"
                  checked={allDay}
                  onChange={handleAllDayChange}
                  className="h-4 p-2 ml-2  w-4 text-blue-600 border-gray-300 rounded"
                />
          </div>

          {!allDay && (
  <div className="md:col-span-2">
    <div className="business-settings-hours-heading">
      <div><h3 className="text-sm font-medium text-black-700 mb-1">Opening Hours</h3><p>Set Monday once, then adjust individual days only when needed.</p></div>
      <button type="button" onClick={copyMondayToAll}>Copy Monday to all</button>
    </div>
    {openingHours
    .slice()
    .sort((a, b) => daysOfWeek.indexOf(a.dayOfWeek) - daysOfWeek.indexOf(b.dayOfWeek))
    .map((item, index) => (
      <div key={index} className="business-settings-hours-row flex items-center gap-4 mb-2">
        <span className="w-1/4 text-gray-700">{item.dayOfWeek}</span>
        

          <div className="business-settings-time-range flex gap-2 w-1/4">
            <input type="time" value={(item.openTime || '').slice(0, 5)} onChange={(e) => handleTimeChange(item.dayOfWeek, "openTime", e.target.value)} className="business-settings-time" aria-label={`${item.dayOfWeek} opening time`} />
            <span className="text-gray-700">to</span>
            <input type="time" value={(item.closeTime || '').slice(0, 5)} onChange={(e) => handleTimeChange(item.dayOfWeek, "closeTime", e.target.value)} className="business-settings-time" aria-label={`${item.dayOfWeek} closing time`} />
          </div>
        
      </div>
    ))}
  </div>
)}
                </div>
         
               
                <div className=" mt-9">
                <label className="text-lg font-semibold mb-4 mt-9">Status</label>
                <div className="flex items-center mt-2">
                  <input
                    type="checkbox"
                    checked={checkedBusy}
                    onChange={handleBusyChange}
                    className="h-4 p-2  w-4 text-blue-600 border-gray-300 rounded"
                  />
                  <label className="ml-2 text-gray-700">Accept Order</label>
                </div>
              </div>
              {!checkedBusy && <div className="mt-7">
                <label className="block text-sm font-medium text-gray-700">Cause Title</label>
                <input
                  type="text"
                  value={causeTitle}
                  onChange={(e) => setCauseTitle(e.target.value)}
                  className="mt-1 p-2  block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                />
              </div>}
              {!checkedBusy && <div className="mt-7">
                <label className="block text-sm font-medium text-gray-700">Cause Description</label>
                <textarea
                   value={causeDescription}
                   onChange={(e) => setCauseDescription(e.target.value)}
                  className="mt-1 p-2  block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                />
              </div>}
              </div>
            </form>
           
          </div>
        </div>
        <div className="mt-5 align-center center">
            <button
                  className="px-5 py-1 bg-white border font-inter border-gray-700 text-gray-700 text-sm rounded-lg hover:bg-yellow hover:text-white hover:border-white "
                onClick={() => handleEditItem() }
                >
                  SAVE
                </button>
                </div>
      </main>
      </section>
    </Layout>
  );
};

export default BusinessSettings;
